import type { ExitPendingApprovalRow } from "./types";

function normalizeExitPhase(exitStatus: string | undefined, fallback?: string): string {
  const raw = exitStatus ?? fallback;
  return String(raw ?? "").toUpperCase();
}

/** True when the pending row is in manager (L1) approval step. */
export function exitRowIsManagerApprovalPhase(row: ExitPendingApprovalRow): boolean {
  const ctx = row.approverContext;
  if (ctx && typeof ctx.isHrStep === "boolean") {
    return !ctx.isHrStep;
  }
  const s = normalizeExitPhase(row.exitStatus, typeof row.status === "string" ? row.status : undefined);
  /** SUBMITTED: may appear on approver queue before status moves to MANAGER_APPROVAL. */
  return (
    s === "MANAGER_APPROVAL" ||
    s === "PENDING_APPROVAL" ||
    s === "SUBMITTED"
  );
}

/** True when the pending row is in HR review step. */
export function exitRowIsHrReviewPhase(row: ExitPendingApprovalRow): boolean {
  const ctx = row.approverContext;
  if (ctx && typeof ctx.isHrStep === "boolean") {
    return ctx.isHrStep;
  }
  return normalizeExitPhase(row.exitStatus, typeof row.status === "string" ? row.status : undefined) === "HR_REVIEW";
}

/**
 * Whether approve/reject/suggest should be enabled for this row.
 * Backend sets `approverContext` only when the viewer is the current approver; do not infer from list membership alone.
 */
export function exitPendingRowUserCanAct(
  row: ExitPendingApprovalRow,
  currentUserId: string | undefined,
): boolean {
  if (!currentUserId) return false;
  if (row.approverContext == null) return false;
  const ids = row.currentActorIds;
  if (Array.isArray(ids) && ids.length > 0) {
    return ids.map(String).includes(String(currentUserId));
  }
  const one = row.currentActorId;
  if (typeof one === "string" && one.length > 0) {
    return String(one) === String(currentUserId);
  }
  return true;
}
